import PageService from "./page-service";

export default PageService;